import styled from 'styled-components';

export default styled.span`
  position: relative;
  top: 0.15em;
  margin-left: 10px;
`;
